export const routes = {
  home: '/',
  oNas: '/o-nas',
  oferta: '/oferta',
  portfolio: '/portfolio',
  kontakt: '/kontakt',
}
